const TCLE_INSTITUTION_FALLBACK = 'Não informado';

function getInstitutionDisplayValue(value) {
  if (value === null || value === undefined) return TCLE_INSTITUTION_FALLBACK;
  const displayValue = String(value).trim();
  return displayValue || TCLE_INSTITUTION_FALLBACK;
}

function formatInstitutionDocument(value) {
  const displayValue = getInstitutionDisplayValue(value);
  if (displayValue === TCLE_INSTITUTION_FALLBACK) return displayValue;
  const digits = displayValue.replace(/\D/g, '');
  if (digits.length !== 14 || !/^[\d./\-\s]+$/.test(displayValue)) return displayValue;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12)}`;
}

function escapeTemplateText(value) {
  const escapedCharacters = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return getInstitutionDisplayValue(value).replace(/[&<>"']/g, (character) => escapedCharacters[character]);
}

function getInstitutionPreviewData(institution) {
  const selectedInstitution = institution && typeof institution === 'object' ? institution : {};
  return {
    document: formatInstitutionDocument(selectedInstitution.document),
    name: getInstitutionDisplayValue(selectedInstitution.name),
  };
}

function generatePreviewHtml(editorHtml, editorCss, institution) {
  const institutionData = getInstitutionPreviewData(institution);
  const html = `<!DOCTYPE html>
  <html>

  <head>
 ${editorCss}
  </head>
  
  <body id="pre-preview">
    <div id="tcle-page-boundary" aria-hidden="true"></div>
      <div id="term-header-1" class="print-header">
          <div id="institution" class="term-institution">
                <img id="institution_logo" src="data:image/svg+xml;base64,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" />              <h2 id="institution_name">${escapeTemplateText(institutionData.name)}</h2>
              <h2 id="institution_document"><span>CNPJ: </span>${escapeTemplateText(institutionData.document)}</h2>
          </div>
          <div id="print-title">
              <h1 id="register_title">TERMO DE CONSENTIMENTO</h1>
          </div>
          <div id="pacient">
          <img id="patient_photo" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNy45IDM3LjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM3LjkgMzcuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMxRDFEMUI7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzAsMjkuMWMtMC4zLTItMS42LTMuOC0zLjUtNC41bC00LjctMi41di0xLjVjMS44LTEuOSwyLjktNC40LDIuOS03LjF2LTEuNGMwLTAuMywwLTAuNi0wLjEtMXYwCgljLTAuNS0yLjUtMi42LTQuMi01LjEtNC4yaC0xYy0yLjUsMC00LjcsMS44LTUuMSw0LjJjLTAuMSwwLjMtMC4xLDAuNi0wLjEsMXYxLjRjMCwyLjYsMS4xLDUuMiwyLjksNy4xbDAsMS41bC00LjcsMi40CgljLTEuOSwwLjgtMy4zLDIuNS0zLjYsNC41bC0wLjIsMS4zYzAsMC4zLDAsMC42LDAuMiwwLjhjMC4yLDAuMiwwLjUsMC4zLDAuNywwLjNoMjAuNmMwLjMsMCwwLjYtMC4xLDAuNy0wLjMKCWMwLjItMC4yLDAuMy0wLjUsMC4yLTAuOEwzMCwyOS4xeiBNMTQuMywxMi4xYzAtMC4zLDAtMC41LDAuMS0wLjhjMC40LTIsMi4xLTMuNCw0LjEtMy40aDFjMiwwLDMuOCwxLjQsNC4xLDMuNAoJYzAsMC4zLDAuMSwwLjUsMC4xLDAuOHYxLjRjMCwyLjUtMS4xLDQuOS0yLjksNi43Yy0xLDEtMi42LDEtMy42LDBjLTEuOC0xLjctMi45LTQuMi0yLjktNi43VjEyLjF6IE04LjcsMzAuNWwwLjItMS4zCgljMC4yLTEuNywxLjQtMy4xLDMtMy44bDQuNy0yLjRjMC40LTAuMSwwLjYtMC41LDAuNi0wLjl2LTAuN2MwLjYsMC4zLDEuMiwwLjUsMS44LDAuNWMwLjYsMCwxLjMtMC4yLDEuOC0wLjV2MC43CgljMCwwLjQsMC4yLDAuOCwwLjYsMC45bDQuOCwyLjVjMS42LDAuNiwyLjcsMi4xLDIuOSwzLjdsMC4yLDEuM0w4LjcsMzAuNXoiLz4KPC9zdmc+Cg==" alt="patient" />              <div class="procedure-part">
                  <h2 id="patient_name"> <span></span>Nome do Paciente</h2>
              </div>
              <div class="pacient-part">
                  <h2 id="patient_birth_date"> <span>Data de nascimento: </span> Data de nacimento do paciente </h2>
                  <h2 id="patient_cpf"><span>CPF: CPF do paciente</span></h2>
              </div>
          </div>
      </div>
      <div id="pre-sub-header-1" class="sub-header">
          <div>
                <img id="ax-logo" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAI0AAAAmCAIAAAB254/fAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABppJREFUeNrsm0tWIkkUhrUPY1xAQ80LagHiAnzMG2te6LygaqxY41IX4GPuY664AKgFqAso2ABsgP7k7xNGZ2RGBgmIp07ew6Et4kbEjXvj/veR2avj8Xglp3dPf7k/9Xq9/f290Wjkmdbp3MPjX/r09OToqJ2reFF2+vWrhxmenp48056fn+HxL806FxfnuYoXZaeccjvllNvpj6aCkgLijR1X+L69vdEfSbFHmYJn6X5/EOEpFouNxl6u9Ay0Sl5O5paaFMyL7u461Wo113sWOykXNz/hSTc312jTn/JBITxXVzfm73K5VCqVw4UbDPqIsjgv5JiDwSBpFFkrleo7uVUF/adWq0Uw7eCgLYP5bfD5c91vKnvl6fV4I9hEX7Osk0Qc0L6gCdYq1+t1LgrXZfl2iqXj4xNduiQGRA8xVTai0Dbl1+XlxSLsJDo8bHMP4mrEJ5WJ3BVuzNnZ+RJ9q+AfXqKpMBKmajZb6AhlgYFTYWY4JTmrfsSKR0dtNMAZ7+87C5JhDnk5pqrXdz0MMtXc7xrm4RvMaTabk7zxdCkK4nTSAJfm27fWu66f3t5UkwjfZ9NJeNhlff2yLDXhVchAMFuWDKF17hubSt4jT4KU78nDXOKaA0r+lEc8qVmD53RbW9uRxNgmfmeLjY3ahw8lPjs7W/wzZDtNhF8TWYEyyT4LYgO8U/Qj3sxUikaEBxMMlG4pYrn8X740iI4cJilGThKB62JxbZZkhDR9UioM3HwHVZqLUpvQcDhSSPM8ebAnIrkmrq0VOb5MLjPzTUazMnbo5OS4XP672+2O46jVajKqTyzDcDjc3t708/hpd/cfVwDti2yxU66vrxhlX3aPDN3f3zFUq627Q7EbJZHUEhHAHJalHh8f7SGW1VCsVP3+72r1o0aRMLImu2hUwrP41HayTZXEYJtqWiOxr6R3DyZ1+6Xi21UHn4gSM9ip3T6E+fz8zF0hsqkrFXMjv0s/nolIDo+sxS5Z+nsgACiE23r6e+vrNaFQhCe1YGRfQVlcvbkLRPCJhV9gGXxgtFKpKJ4hoWCHoXmgcUfnskMLBFipeklKQOABsRuNhoFxAR0ieSbC/PPnCaj4378x3d5ew8DUQj/cDq6J5876nUau5nEpAybynlgPy+ZPuJG7tfSWOl2YbLuUnClkXzlxRtwzPHasSvpMBXpaMIItrmYjgO7aEmtJsy5+ZrCTFO1yClFTD0UUkK7NL5IwRCFcuFfcy0yp3YppG0WTrKzoySrBQ2Dk8vJCWXJsE6HZbOnVDJY6O8v+4J+ck71MD5DD2uniaEKgk//hjg2S+kPhIBCHDVthRuXO0VTq5vkDGOZBNSYwxPKwgnQn5tR9X2NAciv54KAd0azUjS0D7WQbeP79vTczlem6Pjx0PM8n7XQjyU77+w0Vc4i0ubmZ5Hn2nU26GdwGpsc6pcyGDPaDm3AXCbSWaX8U5gJZs5uKuYKR1McH5XJpNBrC32w2XXfhdsvV8AAchYIRHj/IwBlrcuTZ3t4iGY7NMCVnhu4zExGJiSGd5deOxix5hKcEnjaPIJWC2Z8NulmMv6T1FL+BeYTCeFKaGpjvhRdVSWpBznm+x5LaWPJ3Xe1GkZ8Uw+SCNkSonw1M6bIjDB+1lLKdCEckK1Ed5o4Cqnz/+DH14iCB2mCpPUmDe3N+3yibqdR1/fq1FQ4dijr2e5wqaakrbZRThYs6Mr/xiZ24QBjbzRc4qYb8zzv0+CpSwyKnLBErmJ6h/A9v54h74T3AkEaRn1QRg0jCNE9JGyl+M9RPZgWXk91Na8cdZaK2sIsntywD3MBAQJsV+JFTaE0dZw51bioEh9hJJ0G+bChPPZsahxS3jFEz9CM8zVx+0TpiQCqUw7fpcDKaJBiGjA3qrGNqea3w8r4RHm2nwv3+AFj0ZKuGx/+YQLmKzVMsrgFE9rKAxs7OFjjQ7U79ZIj1yeiYS/q3MnmpxpPXAT4gDAx3dx27cmIRJoY87zBAFNuUIy28vb3t9bomZHLMWm2Dwjx1caYo/UOn6+s1+60shj59qrDCAu3E3mwT4eGQy3rF4M3IU4Nnu4svUWpBuGdQZZzTDGSwPX+/fDkUkoICSEoU8afcTsshShFCpueVDSGeCgMCUCFX2VKIYvz799akn/ySCk1q/JLJHUgX1JHCk7BTfH9P6QNZR2qxmcaw9senDJlJmSew9vDwQJboNiYo5O1ccTX2/6PGpKlmCGkjhqyTk8mN7ScpEYZ/BRgAn2DDpnThN+sAAAAASUVORK5CYII=" />                  <ul class="summary-list axpre-summary">
                      <li><span>Nesta página:</span></li>
                      <li>Termo de Consentimento Informado para Procedimento Anestésico (Norma Técnica Resolução SS- 002,
                          de
                          06 de janeiro de 2006)</li>
                  </ul>
              </div>
          </div>
      </div>
      <div class="term-content-text">
          <div class="grid-container-text" style="row-gap:0">
              <div class="grid-item-text">
                  <p style="font-weight:700;text-align:justify;">Prezado Paciente ou Representante legal, o termo de
                      consentimento livre e esclarecido somente deverá ser assinado se todas as dúvidas já tiverem sido
                      esclarecidas. Caso ainda tenha alguma dúvida, esclareça com a equipe médica. A assinatura deste
                      documento representa o expresso consentimento esclarecido na realização do procedimento indicado,
                      bem
                      como no comprometimento em seguir as orientações médicas, inclusive quanto ao tratamento com equipe
                      multidisciplinar.</p>
              </div>
              
              <div class="grid-container-text">
                  <div id="tcle-custom-content" class="grid-item-text">
                  ${editorHtml || ''}
                  </div>
                  </div>
              <div class="grid-item-text">
                  <div class="grid-container-footer">
                      <div class="grid-item-footer">
                      </div>
                      <div class="grid-item-footer" style="justify-self:end">
                          <p><span>Cidade,&nbsp; Data.Hora</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="section-clear"></div>
      <div id="tcle-protected-region" class="section-header pre-section-header">
      <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAzNy45IDM3LjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDM3LjkgMzcuOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiMxRDFEMUI7fQo8L3N0eWxlPgo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMzAsMjkuMWMtMC4zLTItMS42LTMuOC0zLjUtNC41bC00LjctMi41di0xLjVjMS44LTEuOSwyLjktNC40LDIuOS03LjF2LTEuNGMwLTAuMywwLTAuNi0wLjEtMXYwCgljLTAuNS0yLjUtMi42LTQuMi01LjEtNC4yaC0xYy0yLjUsMC00LjcsMS44LTUuMSw0LjJjLTAuMSwwLjMtMC4xLDAuNi0wLjEsMXYxLjRjMCwyLjYsMS4xLDUuMiwyLjksNy4xbDAsMS41bC00LjcsMi40CgljLTEuOSwwLjgtMy4zLDIuNS0zLjYsNC41bC0wLjIsMS4zYzAsMC4zLDAsMC42LDAuMiwwLjhjMC4yLDAuMiwwLjUsMC4zLDAuNywwLjNoMjAuNmMwLjMsMCwwLjYtMC4xLDAuNy0wLjMKCWMwLjItMC4yLDAuMy0wLjUsMC4yLTAuOEwzMCwyOS4xeiBNMTQuMywxMi4xYzAtMC4zLDAtMC41LDAuMS0wLjhjMC40LTIsMi4xLTMuNCw0LjEtMy40aDFjMiwwLDMuOCwxLjQsNC4xLDMuNAoJYzAsMC4zLDAuMSwwLjUsMC4xLDAuOHYxLjRjMCwyLjUtMS4xLDQuOS0yLjksNi43Yy0xLDEtMi42LDEtMy42LDBjLTEuOC0xLjctMi45LTQuMi0yLjktNi43VjEyLjF6IE04LjcsMzAuNWwwLjItMS4zCgljMC4yLTEuNywxLjQtMy4xLDMtMy44bDQuNy0yLjRjMC40LTAuMSwwLjYtMC41LDAuNi0wLjl2LTAuN2MwLjYsMC4zLDEuMiwwLjUsMS44LDAuNWMwLjYsMCwxLjMtMC4yLDEuOC0wLjV2MC43CgljMCwwLjQsMC4yLDAuOCwwLjYsMC45bDQuOCwyLjVjMS42LDAuNiwyLjcsMi4xLDIuOSwzLjdsMC4yLDEuM0w4LjcsMzAuNXoiLz4KPC9zdmc+Cg==" />          
      <p style="line-height:2.5">PACIENTE/RESPONSÁVEL</p>
      </div>
      <div class="section-clear"></div>
      <div class="section-clear"></div>
      <div class="grid-patient-section">
          <div class="grid-item-patient-name enunciated"style="line-height: 2.0;">Nome Paciente:&nbsp;<span class="enunciated-answer"
                  style="font-weight:100;display:contents;"style="line-height: 2.0;">Nome do paciente ou responsável</span></div>
          <div class="grid-item-patient-document enunciated"style="line-height: 2.5;">CPF:&nbsp;<span class="enunciated-answer">CPF do paciente ou responsável</span></div>
          <div class="grid-item-patient-kinship enunciated"style="line-height: 3.0;">Grau de parentesco (se responsável):<span class="enunciated-answer">Grau de parentesco do responsável</span></div>
          <div class="grid-item-patient-signature enunciated"style="line-height: 1.5;">Assinatura Paciente:<span class="signature_patient_resp"></span></div>
      </div>
      <div class="section-clear"></div>
      <div class="section-header pre-section-header">
      <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxOS4xIDE5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxOS4xIDE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6IzFEMUQxQjt9Cgkuc3Qxe2ZpbGw6I0ZGRkZGRjt9Cjwvc3R5bGU+CjxnPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTkuNiwxOUgwLjFWMGg5LjVDMTQuOCwwLDE5LDQuMywxOSw5LjV2MEMxOSwxNC43LDE0LjgsMTksOS42LDE5eiIvPgo8L2c+CjxwYXRoIGNsYXNzPSJzdDEiIGQ9Ik0xMy4zLDcuOWgtMi43Yy0wLjEsMC0wLjMtMC4xLTAuMy0wLjNWNC45YzAtMC4xLTAuMS0wLjMtMC4zLTAuM0g3LjNDNy4yLDQuNiw3LDQuOCw3LDQuOXYyLjcKCWMwLDAuMS0wLjEsMC4zLTAuMywwLjNINC4xQzMuOSw3LjksMy44LDgsMy44LDguMXYyLjdjMCwwLjEsMC4xLDAuMywwLjMsMC4zaDIuN2MwLjEsMCwwLjMsMC4xLDAuMywwLjN2Mi43YzAsMC4xLDAuMSwwLjMsMC4zLDAuMwoJSDEwYzAuMSwwLDAuMy0wLjEsMC4zLTAuM3YtMi43YzAtMC4xLDAuMS0wLjMsMC4zLTAuM2gyLjdjMC4xLDAsMC4zLTAuMSwwLjMtMC4zVjguMUMxMy41LDgsMTMuNCw3LjksMTMuMyw3Ljl6Ii8+Cjwvc3ZnPgo=" />          
      <p style="line-height:2.5">MÉDICO ANESTESIOLOGITA QUE REALIZOU O PRÉ-ANESTÉSICO</p>
      </div>
      <div class="section-clear"></div>
      <div class="grid-anesthesiologist-text">
          <div class="grid-anesthesiologis-text-item">
              <p style="font-family:Roboto Condensed;font-size:12px; line-height: 1.5;">Confirmo que expliquei detalhadamente para o paciente
                  e/ou responsável o próposito, benefícios, e alternativas para a anestesia e procedimento(s) a ser(em)
                  realizado(s), o mesmo confirmou o entendimento das informações que lhe foram transmitidas e na mesma
                  oportunidade sanou todas as suas dúvidas.</p>
          </div>
          <div class="grid-anesthesiologis-text-item">
              <div class="grid-anesthesiologist-footer">
                  <div class="grid-anesthesiologist-footer-item">
                      <div class="enunciated">Nome Anestesiologista:&nbsp;<span class="enunciated-answer"
                              style="font-weight:100;display:contents; line-height: 2.4;">Nome do anestesiologista</span></div>
                      <div class="enunciated">CRM:&nbsp;<span class="enunciated-answer"
                              style="font-weight:100;display:contents">CRM do anestesiologista</span></div>
                  </div>
                  <div class="grid-anesthesiologist-footer-item">
                      <div class="grid-item-patient-signature enunciated">Assinatura Anestesiologista:<span
                              class="signature_anesthetist enunciated-answer"></span></div>
                  </div>
              </div>
          </div>
      </div>
      <div id="tcle-page-content-end" class="section-clear"></div>
  </body>
  `;

  return html;
}
function generatePreviewCss() {
  const css = `
    <style>
    :host {
      box-sizing: border-box;
      overflow-wrap: break-word;
    }

    :host *, :host *::before, :host *::after {
      box-sizing: border-box;
    }

    :host h1, :host h2, :host h3, :host h4, :host h5, :host h6 {
      font-weight: 500;
    }

    :host p {
      margin-top: 0;
    }
  
      .page-content {
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px 20px 20px;
    }
    
    #col5 {
        border-right: none;
    }
    
    .section-clear {
        clear: both;
    }
    
    .section-header {
        margin: 15px 0 5px;
        background-color: #E9E9EA!important;
        position: relative;
        width: 100%;
        height: 28px;
        font-size: 12px;
        font-weight: 600;
    }
    
    .section-header img {
        height: 28px;
        width: auto;
        float: left;
    }
    
    .section-header p{
        width: auto;
        margin: 7px 4px;
        padding: 0px;
        background-color: transparent;
        position: relative;
        text-transform: uppercase;
        clear: none;
    }
    
    p.patient-data{
        padding-top: 2px;
        padding-bottom: 3px;
    }
    
    p.description {
        padding-top: 2px;
        padding-bottom: 3px;
        padding-left: 2px;
        font-size: 7px;
    }
    
    h4.patient-data{
        font-size: 10px;
    }
    
    #col1 > div:nth-child(2) {
        margin-top: -2px;
    }
    
    .signature-paragraph {
        text-align: center;
    }
    
    .signature-paragraph img{
        display: inline;
        width: 80%;
        min-height: 80px;
    }
    
    .mallanpati-paragraph {
        text-align: left;
    }
    
    .mallanpati-paragraph img {
        height: 70px;
    }
    
    .mallanpati-paragraph {
        display: inline;
    }
    
    .empty-section {
        margin-bottom: 10px!important;
    }
    
    
    .subsection-header {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 9pt;
    }
    
    .totals-list-item {
        /* border-top: 0.5px solid #eaeaea; */
        padding: 2px 0;
        display: list-item;
        list-style-type: disc;
        list-style-position: inside;
        margin: 2px 0 2px 5px;
    }
    
    .totals-list-item span {
        margin-left: -2px;
    }
    
    .content-separator{
        background-color: silver;
        width: 1px;
        float: left;
    }
    @font-face {
      font-family: "Roboto Condensed";
    }
    @font-face {
      font-family: "Roboto Condensed";
      font-weight: bold;
    }
    #pacient span,  #sumary span {
      font-weight: 700;
    }
    
    #print-header, .print-header {
      display: flex;
      min-height: 63px;
      padding: 15px 20px 0;
      box-sizing: border-box;
    }
    
    #header-template {
      display: none;
    }
    
    #institution {
      position: relative;
      width: 25%;
      min-height: 30px
    }
    
    #institution_logo, #patient_photo {
      height: 40px;
      float: left;
      margin-right: 5px;
      margin-top: 3px;
    }
    
    #institution_name {
      margin: 4px 0px;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    
    #institution_document {
      margin: 0px 0px;
      font-size: 10px!important;
      font-weight: 400;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
    
    #print-title {
      padding: 0px 10px;
      box-sizing: border-box;
      position: relative;
      border-left: solid 1px silver;
      border-right: solid 1px silver;
      width: 160px;
    }
    
    #print-title h1 {
      font-size: 18px;
    }
    
    #pacient {
      position: relative;
      width: 575px;
    }
    
    .pacient-part {
      float: left;
      padding: 0;
      min-width: 220px;
      margin-right: 10px;
    }
    
    .procedure-part {
      margin-bottom: 0px;
    }
    .procedure-part h2 {
      margin: 0px 0px;
      font-size: 14px !important;
      font-weight: 700;
    }
    .pacient-part h2, .pacient-detail-part h2 {
      margin: 0px 0px;
      font-size: 9px !important;
      font-weight: 400;
    }
    
    #sub-header, .sub-header {
      padding: 10px 20px 0px;
      box-sizing: border-box;
      height: 40px;
    }
    
    #sub-header div:first-child, .sub-header div:first-child {
      height: 28px;
      border-top: solid 1px silver;
      border-bottom: solid 1px silver;
    }
    
    #ax-logo {
      float: left;
      margin-top: 3px;
      height: 22px;
    }
    
    .summary {
      font-size: 8px;
      padding: 4px 8px;
      float: left;
    }
    
    .summary-list {
      margin-top: 5px;
    }
    
    .summary-list span{
      font-weight: 600;
    }
    
    .summary-list li {
      float: left;
      list-style: none;
      font-size: 8px;
      padding: 0 3px;
      border-right: 1px solid silver;
      line-height: 11px;
    }
    
    .summary-list li:first-child {
      border-right: none;
      padding-left: 0; 
    }
    
    .summary-list li:last-child {
      border-right: none;
      padding-right: 0; 
    }
    
    #pre-preview{
      color: black;
      background: white;
      margin: 0;
      width: 100%;
      font-family: "Roboto Condensed", sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    #tcle-page-boundary {
      box-sizing: border-box;
      height: 29.7cm;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
    }
    
    #pre-preview h1, #register_title, #pre-preview h3, #pre-preview p {
      margin: 0;
      width: auto;
      float: left;
    }
    
    h2 {
      font-size: 14px;
    }
    
    ul, li {
      margin: 0;
      padding: 0;
    }
    
    table, tbody, tr, td{
      padding: 0px !important;
      margin: 0px !important;
      border-collapse: collapse;
      white-space: nowrap;
    }
    
    table, tbody, tr{
      width: 100% !important;
    }
    table, tbody{
      height: 100% !important;
    }
    
    td{
      border:solid 1px silver!important;
      word-wrap:break-word;
      text-align: center;
      white-space: nowrap;
    }
    
    .text-paragraph {
        margin-top: 10px;
    }
    
    .portrait {
        transform: rotate(270deg) translate(-276mm, 0);
        transform-origin: 0 0;
        width: 21cm !important;
        height: 29.7cm !important;
        left: 0px !important;
        bottom: 250px !important;
        position: relative !important;
        padding: 20px !important;
        box-sizing: border-box !important;
    }
    
    
    .no-portrait {
        width: 21cm !important;
        height: 29.7cm !important;
        left: 0px !important;
        position: relative !important;
        padding: 20px !important;
        box-sizing: border-box !important;
    }
    
    .page-content .page-content{
        padding: 0 20px 10px 10px;
    }
    
    .term-content-text{
        /*padding: 20px;*/ font-family:"Roboto Condensed"; font-size: 12px; line-height: 10.8pt;  
    }
    .term-technique{
        font-weight: bold;
    }
    
    .term-paragraph{
        width: 100%;
        margin-top: 10px;
    }
    
    .term-title{
        font-weight: bold;
    }
    
    .term-paragraph-flex{
        margin-top: 10px;
        display: flex;
    }
    
    .term-signature-img{
        max-width: 170px;
    }
    
    .signature_patient_resp{
        display: block;
    }
    .signature_spectator{
        display: block;
    }
    
    
    .term-institution{
        width: 60% !important;
    }
    
    .consent-term-footer {
       margin-top: 20px;
    }
    
    .grid-container-text {
        display: grid;
        row-gap: 20px;
        
    }
    
    .grid-item-text {
        display: inline-grid;
    }

    /* AXREG-3226: #tcle-custom-content é um inline-grid item e herda min-width: auto do CSS
       grid, então uma sequência sem espaços expande o bloco além da folha (medido: 4333px
       contra 952px de página) em vez de quebrar linha. Isso faz o gate de Save rejeitar
       conteúdo que ocupa só uma fração pequena da altura da página. Esta regra precisa viver
       no template compartilhado (não em um estilo restrito ao modal de Preview) porque tanto o
       preview visível quanto a cópia oculta usada para medir a geometria real do Save
       renderizam este mesmo HTML/CSS. */
    #tcle-custom-content,
    #tcle-custom-content > p {
        min-width: 0;
        max-width: 100%;
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    #tcle-custom-content > p {
        width: 100%;
    }

    .grid-container-footer {
        display: grid;
        grid-template-columns: 50% 50%;    
    }
    
    .grid-item-footer {
        display: inline-grid;
    }
    
    .grid-patient-section {
        display: grid;
        grid-template-columns: 70% 30%;
        grid-template-rows: 20% 20% 20%;    
    }
    
    .grid-item-patient-name {
        display: inline-grid;
        grid-column: 1;
        grid-row: 1;
        justify-self: start;    
    }
    
    .grid-item-patient-document {
        display: inline-grid;
        grid-column: 1;
        grid-row: 2;
        justify-self: start;
    
    }
    
    .grid-item-patient-kinship {
        display: inline-grid;
        grid-column: 1;
        grid-row: 3;
        justify-self: start;
    }
    
    .grid-item-patient-signature {
        display: inline-grid;
        grid-column: 2;
        grid-row-start: 1;    
        justify-content: center;
    }
    
    .enunciated {    
        line-height: 11px;
        font-size: 12px;
        font-family:"Roboto Condensed";
        font-style: normal;
        font-weight: bold;
    }
    
    .enunciated-answer {
        font-weight: 400;
        font-size: 12px;
        font-family:"Roboto Condensed";
        display: contents;
    }
    
    .grid-anesthesiologist-text {
        display: grid;
        grid-template-rows: 50% 50%;
    }
    
    .grid-anesthesiologis-text-item {
        display: inline-grid;
    }
    
    .grid-anesthesiologist-footer {
        display: grid;
        grid-template-columns: 70% 30%;
    }
    
    .grid-anesthesiologist-footer-item {
        display: inline-grid;
    }
    
    </style>
    `;
  return css;
}
module.exports = {
  escapeTemplateText,
  formatInstitutionDocument,
  generatePreviewHtml,
  generatePreviewCss,
  getInstitutionPreviewData,
  TCLE_INSTITUTION_FALLBACK,
};
